import React from "react";
import queryString from 'querystring';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiGet, getHostApi, hasPermission } from '../../store/apiWrapper';
import classnames from 'classnames';
import DownloadFileButton from "../files/downloadFileButton";

import XlsxExport from '../../img/icons/BBicons_Export-XLSX';

class ExcelExportButton extends React.Component {
    static defaultProps = {
        style: {},
        check: false,
        onCheckFailed: () => null,
        onCheckSuccessful: () => null
    };

    state = {
        isChecking: false,
    };

    render() {
        if (!hasPermission(null, 'ReportExport'))
            return null;

        const link = this.generateLink();
        if (link === null && isNullOrUndefined(this.props.onClick))
            return null;

        const checkLink = this.generateCheckLink();

        if (this.props.asButton)
            return isNullOrUndefined(checkLink) ? this.renderButton(link) : this.renderCheckButton(link, checkLink);
        else
            return isNullOrUndefined(checkLink) ? this.renderLink(link) : this.renderCheckLink(link, checkLink);
    }

    renderLink = (link) => {
        return (
            <div style={{ fontSize: "0.9em", ...this.props.style }} className="print-hidden is-hidden-mobile">
                {this.props.disabled ? <span style={{ display: "flex", marginRight: "auto", cursor: "not-allowed" }}>
                    {this.renderLinkInner(true)}
                </span> :
                    <DownloadFileButton link={link} onClick={this.props.onClick}
                        title={isNullOrUndefined(this.props.title) ? "Excel" : this.props.title}
                        style={{ display: "flex", marginRight: "auto" }} disabled={this.props.disabled}>
                        {this.renderLinkInner(false)}
                    </DownloadFileButton>
                }
            </div>
        );
    }

    renderLinkInner = (disabled, isCheckLink = false) => {
        const cursor = disabled ? "not-allowed" : "pointer";
        return (
            <>
                <XlsxExport className="svg-standard-fill icon-centered export-icon" style={{ width: "1.5em", height: "1.5em", cursor: cursor }} />
                <span className="link-external" style={{ marginLeft: "0.5em", cursor: cursor }}>
                    <Translate id="Common.ExportToExcel" />
                </span>
                {isCheckLink && this.state.isChecking ? <span style={{ marginLeft: "0.25em" }}><FontAwesomeIcon icon="cog" color="#898989" spin /></span> : null}
            </>
        );
    }

    renderButton = (link) => {
        return (
            <>
                <DownloadFileButton link={link} asButton
                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                    disabled={this.props.disabled}
                >
                    <Translate id="Common.ExportToExcel" />
                </DownloadFileButton>
            </>
        );
    }

    renderCheckLink = (link, checkLink) => {
        return (
            <div style={{ fontSize: "0.9em", ...this.props.style }} className="print-hidden is-hidden-mobile">
                {this.props.disabled ? <span style={{ display: "flex", marginRight: "auto", cursor: "not-allowed" }}>
                    {this.renderLinkInner(true, true)}
                </span> : <>
                    <DownloadFileButton link={link} style={{ display: 'none' }} id='downLnk' />
                    <span
                        onClick={() => {
                            this.setState({ isChecking: true })
                            apiGet(checkLink, null,
                                (s) => {
                                    this.setState({ isChecking: false });
                                    if (s.data.isSuccess) {
                                        this.props.onCheckSuccessful();
                                        document.getElementById('downLnk').click();
                                    } else
                                        this.props.onCheckFailed(s.data.exception || "Common.Error", s.data.exceptionData);
                                },
                                (_) => {
                                    this.setState({ isChecking: false });
                                    this.props.onCheckFailed("Common.Error");
                                }
                            );
                        }}
                        title={isNullOrUndefined(this.props.title) ? "Excel" : this.props.title}
                        style={{ display: "flex", marginRight: "auto", alignItems: "center" }} disabled={this.props.disabled}
                    >
                        {this.renderLinkInner(false, true)}
                    </span>
                </>}
            </div>
        );
    }

    renderCheckButton = (link, checkLink) => {
        return (
            <>
                <DownloadFileButton link={link} style={{ display: 'none' }} id='downLnk' />
                <button type="button"
                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                    disabled={this.props.disabled}
                    onClick={() => {
                        this.setState({ isChecking: true })
                        apiGet(checkLink, null,
                            (s) => {
                                this.setState({ isChecking: false });
                                if (s.data.isSuccess) {
                                    this.props.onCheckSuccessful();
                                    document.getElementById('downLnk').click();
                                } else
                                    this.props.onCheckFailed(s.data.exception || "Common.Error", s.data.exceptionData);
                            },
                            (_) => {
                                this.setState({ isChecking: false });
                                this.props.onCheckFailed("Common.Error");
                            }
                        );
                    }}
                >
                    {this.state.isChecking ? <FontAwesomeIcon icon="cog" color="#898989" spin /> : <Translate id="Common.ExportToExcel" />}
                </button>
            </>
        );
    }

    generateLink = () => {
        if (!isNullOrUndefined(this.props.ceeCre) && !isNullOrUndefined(this.props.country))
            return this.generateCeeCreLink(this.props.ceeCre, this.props.country);
        else if (!isNullOrUndefined(this.props.rpve))
            return this.generateRpveLink(this.props.rpve);
        else if (!isNullOrUndefined(this.props.portfolio))
            return this.generatePortfolioLink(this.props.portfolio, this.props.report);
        else if (!isNullOrUndefined(this.props.industryAnalysis))
            return this.generateIndustryAnalysisLink(this.props.industryAnalysis);
        else if (!isNullOrUndefined(this.props.propertySk))
            return this.generatePropertySkLink(this.props.propertySk);
        else if (!isNullOrUndefined(this.props.ratiobook))
            return this.generateRatiobookLink(this.props.report, this.props.ratiobook);
        else if (!isNullOrUndefined(this.props.link) && this.props.link.length !== 0 && !isNullOrUndefined(this.props.entityId)) {
            return this.generateReportLink(this.props.entityId, this.props.link,
                isNullOrUndefined(this.props.report) ? "GlobalReport" : this.props.report, this.props.additionalParams || {}, this.props.orderBy)
        }
    }

    generateCheckLink = () => {
        if (!isNullOrUndefined(this.props.propertySk) && this.props.check === true)
            return this.generatePropertySkLink(this.props.propertySk, this.props.check);
        return null;
    }

    generateCeeCreLink = (id, country) =>
        `${getHostApi()}/api/excel-export/cee/${id}?${queryString.stringify(this.getAllParams({ country: country }))}`;


    generateRpveLink = (id) =>
        `${getHostApi()}/api/excel-export/rpve/${id}`;
    

    generateReportLink = (entityId, link, report, params) =>
        `${getHostApi()}/api/excel-export/${entityId}/${link}?${queryString.stringify(this.getAllParams({ report: report, ...params }))}`;


    generatePortfolioLink = (id, report) => {
        if (!isNullOrUndefined(report))
            return `${getHostApi()}/api/portfolio/${id}/${report}/export?${queryString.stringify(this.getAllParams())}`;
        else
            return `${getHostApi()}/api/portfolio/${id}/export?${queryString.stringify(this.getAllParams())}`;
    }

    generateIndustryAnalysisLink = (iaParams) =>
        `${getHostApi()}/api/excel-export/industry-analysis?${queryString.stringify(this.getAllParams(iaParams))}`;

    generatePropertySkLink = (propertySkParams, check = false) => {
        return `${getHostApi()}/api/excel-export/property-sk/${(check ? "check/" : "")}${propertySkParams.link}?` +
            queryString.stringify(this.getAllParams(propertySkParams.params));
    }

    generateRatiobookLink = (report, rbParams) =>
        `${getHostApi()}/api/excel-export/ratiobook/${report}/?${queryString.stringify(this.getAllParams(rbParams))}`;

    getAllParams = (params = {}) => ({ ...params, ascending: this.props.ascending });
}

export default withLocalize(withRouter(connect(
    state => ({ language: state.userContext.language }),
)(ExcelExportButton)));